import { render, staticRenderFns } from "./linear_statistic.vue?vue&type=template&id=4fce9f32&"
import script from "./linear_statistic.vue?vue&type=script&lang=js&"
export * from "./linear_statistic.vue?vue&type=script&lang=js&"
import style0 from "./linear_statistic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/yong9/vege_v2/vege_v2/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VIcon})
